import React from 'react'
import { motion } from 'framer-motion'
import { images } from '../../constants'
import './Header.scss'

import { AppWrap } from '../../wrapper'

const scaleVariants = {
  whileInView: {
    scale : [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: 'easeInOut',
    }
  }
}

const Header = () => {
  return (
    <div className='app__header app__flex'>
      <motion.div
        whileInView={{ x: [-100, 0], opacity: [0,1] }}
        transition={{ duration: 0.5 }}
        className='app__header-info'
      >
        <div className='app__header-badge'>
          <div className='badge-cmp app__flex'>
             <span>👋</span>
             <div style={ { marginLeft: 20 }}>
                <p className='p-text'>Hi there, I am</p>
                <h1 className='head-text'>Emmanuella Ubokabasi</h1>
             </div> 
          </div>

          <div className='tag-cmp app__flex'>
            <p className='p-text'>Web & Mobile Developer</p>
            <p className='p-text'>Tech Writer</p>
            <p className='p-text'>Youtube Tutor</p>
            <p className='p-text'>Drummer</p>
            <p className='p-text'>Mental Health Enthusiast</p>
          </div>
          <div className='tag-cmp-abt app__flex'>
            <p className='p-text'>I am highly <span>motivated</span> and <span>hardworking</span>.
                My primary goal is to provide a <span>satisfactory user experience</span> without <span>issues</span>, <span>errors</span>, or <span>downtime</span>.
                I am passionate and focused on completing work in time to consistently exceed targets. I am a <span>Reliable</span> Team member accustomed to taking on challenging tasks, <span>Dedicated</span> to leverage the <span>functionality</span> of websites, <span>Obedient</span> to instructions and
                <span> Open-minded</span> to learning new concepts. 
            </p>
          </div> 
        </div>
      </motion.div>

    <motion.div
         whileInView={{ opacity: [0,1] }}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className='app__header-img'
    >
      <img src={images.profile} alt='profile_bg' />
    <motion.img
      whileInView={{ scale: [0, 1] }}
        transition={{ duration: 1, easeInOut: 0.5 }}
        src={images.circle}
        alt="profile_circle"
        className='overlay_circle'
    />
    </motion.div>

    <motion.div
      variants={scaleVariants}
      whileInView={scaleVariants.whileInView}
      className='app__header-circles'
    >
      {[images.javascript, images.react,  images.css].map((circle,index ) => (
        <div className='circle-cmp app__flex' key={`circle-${index}`}>
            <img src={circle} alt='circle' />
        </div>
      ))}
    </motion.div>

   
    </div>
  )
}

export default AppWrap(Header, 'home');
